export const composeProviders =
	(...providers) =>
	({ children }) =>
		providers.reduceRight(
			(descendants, Provider) => <Provider> {descendants}</Provider>,
			children
		);
